import {Store, createStore} from 'vuex';
import BaseMapStylesDialogModule, {
  BaseMapStylesState
} from "../.././base_map_dialog/store/modules/BaseMapStylesDialogModule";
import WaypointDialogModule, { WaypointDialogState } from "../../waypoint_dialog/store/module/WaypointOptionsDialogModule";
import ParkMapModule, {ParkMapState} from "./modules/ParkMapModule";
import BaseMapDataPOIsModule, { BaseMapDataPOIsState } from "../../base_map_dialog/store/modules/BaseMapDataPOIsModule";
import BaseMapDataOverlaysModule, { BaseMapDataOverlaysState } from "../../base_map_dialog/store/modules/BaseMapDataOverlaysModule";

declare global {
  interface Window {
    map: mapboxgl.Map;
    trailCenterX: string;
    trailCenterY: string;
  }
}

export interface RootState {
  mapStyles: BaseMapStylesState,
  parkMap: ParkMapState,
  waypoints: WaypointDialogState,
  mapDataOverlays: BaseMapDataOverlaysState
  mapDataPOIs: BaseMapDataPOIsState
}

const store: Store<RootState> = createStore({
  modules: {
    mapStyles: BaseMapStylesDialogModule,
    parkMap: new ParkMapModule(),
    waypoints: WaypointDialogModule,
    mapDataOverlays: BaseMapDataOverlaysModule,
    mapDataPOIs: BaseMapDataPOIsModule,
  }
})

export default store;
